import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';

const LeaveTypeTable = ({ 
    data, 
    onEdit, 
    loading, 
    currentPage,
    setCurrentPage
}) => {
  const headers = [
    "ID", 
    "Description", 
    "Tax Treatment", 
    "Encashable?", 
    "Shield (Limit)", 
    "Max Cash", 
    "Status", 
    "Actions"
  ];

  const accessors = [
    "id", 
    "description", 
    "taxTreatmentName", 
    "isEncashable", 
    "taxExemptLimit", 
    "maxEncashableDays", 
    "isActive", 
    "actions"
  ];

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName={"Leave Types List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
    />
  );
};

export default LeaveTypeTable;